<template>
  <div class="menuscrpt_contianer">
    <div class="owner_title">上传周稿</div>
    <div class="upload_manuscript_box">
      <el-upload
        class="upload-demo  manuscript_upload"
        :action="uploadUrl"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        multiple
        :on-exceed="handleExceed"
        :on-success="uploadSuccess"
        :disabled="uploadState"
      >
        <el-button class="el-upload__text">
          <i class="iconfont icon-shangchuan"></i>上传周稿
        </el-button>
      </el-upload>
      <div slot="tip" class="el-upload__tip" v-show="upload_tip">
        只能上传zip/doc/docx文件
      </div>
    </div>
    <el-form
      ref="filter_form"
      :model="filter_form"
      :inline="true"
      class="demo-form-inline"
      label-width="100px"
    >
      <el-form-item label="书名" prop="connectionessay_name">
        <el-input v-model="filter_form.connectionessay_name"></el-input>
      </el-form-item>
      <el-button type="primary" icon="el-icon-search" @click="goSearch"
        >搜索</el-button
      >
    </el-form>
    <div class="menuscript_table">
      <el-table
        class="table_box"
        height="500"
        :data="dataShow"
        border
        style="width: 98%"
      >
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="departmentuser_name"
          label="金主昵称"
          align="center"
          :width="equipmentType == 0 ? 200 : 110"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="writer_nickname"
          label="写手昵称"
          align="center"
          :width="equipmentType == 0 ? 200 : 110"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="connectionessay_name"
          label="书名"
          align="center"
          :width="equipmentType == 0 ? 400 : 110"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="up_title"
          label="文档名"
          align="center"
          :width="equipmentType == 0 ? 400 : 110"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="record_time"
          label="上传时间"
          align="center"
          :width="equipmentType == 0 ? 180 : 110"
          sortable
        >
        </el-table-column>

        <el-table-column
          label="操作"
          align="center"
          :width="equipmentType == 0 ? 165 : 120"
        >
          <template slot-scope="scope">
            <div class="menuscript_btn_box">
              <div @click="downloadFile(scope.row)" class="menuscript_btn">
                <i class="iconfont icon-xiazai"></i>
                下载稿件
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { week_word, week_zip, week_list } from "@/utils/writer";
import { xz_file } from "@/utils/api";
export default {
  data() {
    return {
      uploadUrl: this.$global.fileUploadUrl,
      writerId: "", //用户id
      filter_form: {
        connectionessay_name: "" //书名
      },
      manuscriptList: [], //查重列表
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      file_list: [], //上传文件路径
      fileUrl: "", //文件上传路径
      uploadState: false, //文件上传前，判断手机还PC   false:可上传  true:不可上传
      upload_tip: true, //上传稿件的提示
      equipmentType: 0 //设备 0-pc端 1移动端
    };
  },
  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      this.equipmentType = 1;
    } else {
      this.equipmentType = 0;
    }
    this.getMenuScript();
  },

  methods: {
    // 获取查重列表
    getMenuScript() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId
      };
      week_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.manuscriptList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    handleUploadMobile() {
      this.$router.push({ path: "uploadFile" });
    },
    // 搜索
    goSearch() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        ...that.filter_form
      };
      console.log("参数", obj);
      week_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.manuscriptList = res.data.data;
          that.calcPageData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 上传稿件
    uploadSuccess(val) {
      var that = this;
      that.fileUrl = val.data.url;
      var suffix = that.fileUrl.substring(that.fileUrl.lastIndexOf(".") + 1);
      if (suffix == "zip") {
        // 上传压缩包
        let zip_obj = {
          departmentuser_id: that.writerId,
          file: that.fileUrl
        };
        week_zip(zip_obj).then(res => {
          that.upload_tip = false;
          console.log(res);
          if (res.data.code == 1) {
            var success_data = res.data.data.success;
            var success_msg = success_data.join(",");
            if (success_msg) {
              that.$message({
                offset: 60,
                type: "success",
                message: success_msg + ",上传成功！"
              });
            }
            that.getMenuScript();
          } else {
            console.log(res.data.msg);
            var fail_arr = [];
            fail_arr = res.data.msg;
            fail_arr.forEach(item => {
              that.$message({
                showClose: true,
                offset: 60,
                duration: 0,
                type: "error",
                message: item
              });
            });
          }
        });
      } else if (suffix == "docx" || suffix == "doc") {
        // 上传word文档
        let docx_obj = {
          departmentuser_id: that.writerId,
          file: that.fileUrl
        };
        week_word(docx_obj).then(res => {
          that.upload_tip = false;
          if (res.data.code == 1) {
            that.$message.success(res.data.msg);
            that.getMenuScript();
          } else {
            that.$message({
              showClose: true,
              duration: 0,
              type: "error",
              message: res.data.msg
            });
          }
        });
      } else {
        this.$message.error("文件格式不符合要求");
      }
    },
    // 下载稿件
    downloadFile(val) {
      console.log(val);
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        weekly_draft_id: val.id
      };
      xz_file(obj).then(res => {
        console.log(res);
        if (res.data.code == 1) {
          var file_url = res.data.data.xurl;
          console.log("file_url", file_url);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = file_url;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href); // 释放URL 对象
          document.body.removeChild(link);
          console.log(link);
          that.$message.success(res.data.msg);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 计算页数的方法
    calcPageData() {
      if (this.manuscriptList.length > 1) {
        this.pageNum =
          Math.ceil(this.manuscriptList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.manuscriptList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  },
  destroyed() {
    //页面关闭时调用
    clearInterval(this.timer);
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}

.upload_manuscript_box {
  text-align: center;
  margin-top: 15px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.upload_tip {
  display: none;
}
.manuscript_upload {
  background: #f3f8ff;
  border: 2px dotted #157df8;
  width: 400px;
  height: 120px;
  line-height: 120px;
}

.manuscript_upload .el-button {
  font-size: 20px;
  border: none;
  background: #f3f8ff;
  color: #157df8;
  font-weight: 500;
}
.menuscrpt_contianer {
  height: 100%;
  background: #ffffff;
}

.menuscript_table {
  padding: 20px;
}
.menuscript_table_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  margin: 10px 15px;
}
.menuscript_btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
.menuscript_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #e7f2ff;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  border-radius: 10px;
}
.menuscript_btn i {
  font-size: 12px;
}
.menuscript_table .el-button:focus,
.el-button:hover {
  color: #fff;
  border-color: #c6e2ff;
  background-color: #157df8;
}
.menuscript_form_dialog {
  width: 400px;
}
.menuscript_form_dialog .el-form-item {
  display: flex;
  flex-direction: row;
}
.menuscript_form_dialog .el-input {
  width: 270px;
  border: 1px solid #dcdfe6 !important;
}
.font_color {
  color: #42d46e;
}
.chapters_color {
  color: #f11c1c;
}
.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.mobile_upload {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background: #f3f8ff;
  border: 2px dotted #157df8;
  width: 515px;
  height: 160px;
  line-height: 158px;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .menuscript_table {
    margin-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/writer/ManuscriptUpload.vue